var defaultStyles = {
  "root": "Base-Input",
  "inner": "Base-Input--Inner",
  "focus": "Base-Input--Focus",
  "label": "Base-Input--Label",
  "label_active": "Base-Input--LabelActive",
  "box": "Base-Input--Box",
  "input": "Base-Input--Input",
  "has_label": "Base-Input--HasLabel",
  "disabled": "Base-Input--Disabled",
  "has_suffix": "Base-Input--HasSuffix",
  "has_prefix": "Base-Input--HasPrefix",
  "has_both": "Base-Input--HasBoth",
  "has_addons": "Base-Input--HasAddons",
  "has_after": "Base-Input--HasAfter",
  "has_before": "Base-Input--HasBefore",
  "default": "Base-Input--Default",
  "filled": "Base-Input--Filled",
  "underlined": "Base-Input--Underlined",
  "error": "Base-Input--Error",
  "warning": "Base-Input--Warning",
  "success": "Base-Input--Success",
  "xs": "Base-Input--Xs",
  "sm": "Base-Input--Sm",
  "md": "Base-Input--Md",
  "lg": "Base-Input--Lg",
  "prefix": "Base-Input--Prefix",
  "suffix": "Base-Input--Suffix",
  "before": "Base-Input--Before",
  "after": "Base-Input--After",
  "mirror": "Base-Input--Mirror",
  "clear": "Base-Input--Clear",
  "has_clear": "Base-Input--HasClear",
  "label_hidden": "Base-Input--LabelHidden"
};

export { defaultStyles as default };
